// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import networkActions from '../../actions/network';
import userActions from '../../actions/user';
import useMergeProps from '../../hooks/useMergeProps';

import WinModal from './WinModal';
import legacyWinModalPropsSelector from './WinModal.selector';

type WinModalContainerProps = {
  className?: string;
  hasNavBarSpacing: boolean;
};

const WinModalContainer = (ownProps: WinModalContainerProps) => {
  const dispatch = useDispatch();
  const selectedProps = useSelector(legacyWinModalPropsSelector);

  const askBetslipInfo = useCallback(
    (betslipReference: string) => {
      dispatch(
        networkActions.send({
          getOneBetslip: {
            betslipReference,
          },
        }),
      );
    },
    [dispatch],
  );
  const clearLastSessionSettledBets = useCallback(() => {
    dispatch(userActions.clearLastSessionSettledBets());
  }, [dispatch]);

  const otherProps = useMemo(
    () => ({
      askBetslipInfo,
      clearLastSessionSettledBets,
    }),
    [askBetslipInfo, clearLastSessionSettledBets],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <WinModal {...enhancedProps} />;
};

export default WinModalContainer;
